import * as Sentry from '@sentry/browser';

if (window.el8Globals.SENTRY_BROWSER_ENABLED) {
  Sentry.init({
    dsn: 'https://b664cc74973988d14807cca2e90e040e@o945999.ingest.us.sentry.io/4506855436386304',
    release: window.el8Globals.SENTRY_RELEASE_NAME ?? '',
    environment: window.el8Globals.ENVIRONMENT,
    enableTracing: false,
    integrations: [],
  });

  const scope = Sentry.getCurrentScope();
  scope.setUser({ id: window.el8Globals.USER_ID });
  scope.setTag('practice_id', window.el8Globals.PRACTICE_ID);
  scope.setTag('ff_AvailabilityOnBkSite', window.el8Globals.FEATURES.AvailabilityOnBkSite);
  scope.setTag('ff_BookViaEmailOrPhone', window.el8Globals.FEATURES.BookViaEmailOrPhone);
  scope.setTag('ff_SchedulingTimeZone', window.el8Globals.FEATURES.SchedulingTimeZone);
}
